<template>
    <div class="wrapper list-item">
      <div v-if="item">
        <div class="campaign-holder">
            <div class="campaign-container">
              <p :class="{unpaired: !item.step2_campaign_id}">
<!--                     <span class="offer-status low"></span> -->
                    <span>{{ item.step1_campaign_id }} - {{ item.step1_campaign_name }}</span>
              </p>
              <p v-if="item.step2_campaign_id"><span>{{ item.step2_campaign_id }} - {{ item.step2_campaign_name }}</span></p>
            </div>
            <div class="vertical-container">
                <p class="vertical-content">{{ item.vertical }}</p>
            </div>
        </div>
        <div class="row summary-container">
            <div class="stats">
                <el-badge :value="item.step1_sales || '0'" :max="9999" class="item s1">
                  <el-button size="small">S1 Sales</el-button>
                </el-badge>
                <el-badge :value="item.step2_sales || '0'" :max="9999" class="item s2">
                  <el-button size="small">S2 Sales</el-button>
                </el-badge>
                <el-badge :value="'$' + parseFloat(item.blended_epc || 0).toFixed(2)" :max="100" class="item epc">
                  <el-button size="small">EPC</el-button>
                </el-badge>
          </div>
        </div>
        <!-- <p v-if="item.step2_campaign_id"><span>Step 2 Conversion: {{ parseFloat(item.step2_conversion).toFixed(2) }}%</span></p> -->
      </div>
      <div v-if="!item">
          <div class="campaign-holder">
            <div class="campaign-container no-results">
              <p><span>Sorry!</span></p>
              <p><span>No Campaigns Available</span></p>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'campaign-list-item',
  props: ['item']
}
</script>
<style src="../static/css/list-item.css"></style>



// WEBPACK FOOTER //
// campaign-list-item.vue?893af8a0